import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useSalesReturn = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [salesReturn, setSalesReturn] = useState(false)
  const { deleteNewSalesReturn, getNewSalesReturn, addNewSalesReturn } = useContext(FeatureContext)
  const [loading, setLoading] = useState(false)

  const getAllSalesReturn = async () => {
    setLoading(true)
    axios
      .get(API.GET_ALL_SALES_RETURN, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewSalesReturn(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addSalesReturn = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_SALES_RETURN, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SalesReturn  Added Successfully', success)
        history.push(ROUTES.SALES_RETURN)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const updateSalesReturn = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_SALES_RETURN, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SalesReturn  Update Successfully', success)
        history.push(ROUTES.SALES_RETURN)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getSalesReturn = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_SALES_RETURN(dto.salesReturnId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setSalesReturn(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteSalesReturn = (dto, setSelected) => {
    setLoading(true)
    axios
      .delete(API.DELETE_SALES_RETURN(dto.salesReturnId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SalesReturn Deleted Successfully', success)

        deleteNewSalesReturn(dto.salesReturnId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManySalesReturn = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_SALES_RETURN, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.salesReturnId.length} SalesReturn Deleted Successfully`, success)

        dto.salesReturnId.map((item) => deleteNewSalesReturn(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        bulkUploadPopup(data, addNewSalesReturn)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    addSalesReturn,
    getAllSalesReturn,
    deleteSalesReturn,
    getSalesReturn,
    salesReturn,
    updateSalesReturn,
    deleteManySalesReturn,
    BulkUpload,
    loading,
  }
}
